let idCounter = 0;

export const uniqueId = (prefix?: string): string => {
  const id = ++idCounter;
  return `${prefix || ""}${id}`;
};
